module.exports = __webpack_public_path__ + "3b5e93a0e2d92ca3e6ae100095e7298b.jpg";